import React from 'react'
import { useState, useEffect, useCallback } from "react";
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';
import ResponsiveStepper from '../components/ResponsiveStepper'
import { CiLink } from "react-icons/ci";
import { MdOutlineModeEdit } from "react-icons/md";

import { MdCurrencyRupee, MdLink } from "react-icons/md";

import Notification from "../components/Notification";
import Modal from "../components/modal";
import { setActiveItem } from '../features/nav/navSlice'
import { getAddons, getBranches, getPackages, getAvailableSlotss, createBookingApi, createPaymentLinkApi, getHappyHours, updateBookingStatus, createPaymentApi } from "../api/reusableApis";
import BasicDatePicker from '../components/BasicDatePicker';

const Bookings = () => {
  const todayIST = new Date().toLocaleDateString('en-CA', {
    timeZone: 'Asia/Kolkata',
  });

  const currentLoggedInUser = useSelector((state) => state.auth.currentUser);
  const [activeStep, setActiveStep] = React.useState(0);
  const [branch, setBranch] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedPackage, setSelectedPackage] = useState("");
  const [selectedEvent, setSelectedEvent] = useState("");
  const [eventDate, setEventDate] = useState(dayjs());
  const [eventDateFormatted, setEventDateFormatted] = useState('');
  const [loader, setLoader] = useState(true);
  const [toast, setToast] = useState({ message: "", type: "success" });
  const [packages, setPackages] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [addons, setAddons] = useState([]);
  const [eventTypeArr, setEventTypeArr] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState('');
  const [selectedSlotobj, setSelectedSlotobj] = useState({});
  const [addonTotalAmount, setAddonTotalAmount] = useState(0);
  const [addonQty, setAddonQty] = React.useState({});
  const [addonArr, setAddonArr] = useState([]);
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [cakeNote, setCakeNote] = useState('');
  const [note, setNote] = useState('');
  const [packageDetails, setPackageDetails] = useState({});
  const [branchDetails, setBranchDetails] = useState({});
  const [timeSlotDetails, setTimeSlotDetails] = useState({});
  const [errors, setErrors] = useState({});
  const [bookingDetails, setBookingDetails] = useState({});
  const [paymentLink, setPaymentLink] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [openAdvanceModal, setOpenAdvanceModal] = useState(false);
  const [copied, setCopied] = React.useState(false);
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [discountAmount, setdiscountAmount] = useState(0);

  const dispatch = useDispatch();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(paymentLink.payment_url);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 3500);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };


  const resetStates = () => {
    setActiveStep(0);
    setSelectedBranch('');
    setSelectedPackage('');
    setSelectedEvent('');
    setEventDate(dayjs());
    setEventDateFormatted('')
    setSelectedSlot('');
    setSelectedSlotobj({});
    setAddonTotalAmount(0);
    setAddonArr([]);
    setAddonQty({});
    setErrors({});
    setTimeSlotDetails({});
    setBranchDetails({});
    setPackageDetails({});
    setNote('');
    setCakeNote('');
    setCustomerEmail('');
    setCustomerPhone('');
    setCustomerName('');
  }


  const handleNext = async () => {
    if (activeStep === 0) {
      if (!selectedBranch || selectedBranch === "none") {
        setToast({
          message: "Please select a branch!",
          type: "error",
        });
        return; // stop moving forward
      }
      if (!eventDate) {

        setToast({
          message: "Please select an event date!",
          type: "error",
        });
        return; // stop moving forward
      }
      setActiveStep((prev) => prev + 1);
    } else if (activeStep === 1) {
      if (!selectedPackage || selectedPackage === "none") {
        setToast({
          message: "Please Select a Package!",
          type: "error",
        });
        return; // stop moving forward
      }
      if (!selectedEvent || selectedEvent === "none") {
        setToast({
          message: "Please Select a Event Type!",
          type: "error",
        });
        return; // stop moving forward
      }
      setActiveStep((prev) => prev + 1);
    } else if (activeStep === 2) {
      if (!timeSlots || timeSlots.length === 0) {
        setToast({
          message: "Time slots are not available for this package",
          type: "error",
        });
        return; // stop moving forward
      }
      if (!selectedSlot || selectedSlot.length === 0) {
        setToast({
          message: "Kindly Select the Time slots.!",
          type: "error",
        });
        return; // stop moving forward
      }
      setActiveStep((prev) => prev + 1);
    } else if (activeStep === 3) {
      const addonsTotal = Object.values(addonQty).reduce(
        (sum, addon) => sum + addon.line_total,
        0
      );
      setAddonTotalAmount(addonsTotal);
      let addOnArrs = [];
      Object.values(addonQty).forEach((value) => {
        console.log(value);
        addOnArrs.push(value);
      });
      setAddonArr(addOnArrs);
      setActiveStep((prev) => prev + 1);
      setAdvanceAmount(packageDetails.advance_amount);
    } else if (activeStep === 4) {
      if (!customerName || customerName.trim().length === 0) {
        setToast({
          message: "Customer Name is required",
          type: "error",
        });
        return; // stop moving forward
      }
      const phoneRegex = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}$/;

      if (!phoneRegex.test(customerPhone.trim())) {
        setToast({
          message: "Invalid phone number format.",
          type: "error",
        });
        return;
      }

      if (customerEmail || customerEmail.trim().length > 0) {
        if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customerEmail))) {
          setToast({
            message: "Customer Email is invalid..!",
            type: "error",
          });
          return; // stop moving forward
        }
      }
      if (!cakeNote || cakeNote.trim().length === 0) {
        setToast({
          message: "Cake note is required!",
          type: "error",
        });
        return; // stop moving forward
      }

      // Validation: If advanceAmount is LESS THAN the package requirement, show error
      if (!advanceAmount || Number(advanceAmount) < Number(packageDetails.advance_amount)) {
        setToast({
          message: `Advance Amount should be Rs. ${packageDetails.advance_amount} or greater.`,
          type: "error",
        });
        return;
      }

      if (Number(discountAmount) && Number(discountAmount) < 0) {
        setToast({
          message: `Discount amount can not be less than zero`,
          type: "error",
        });
        return;
      }

      if (packageDetails?.hasHappyHour && packageDetails?.hhDetails) {
        const hh = packageDetails.hhDetails;

        // Helper: Converts "09:00 AM" to minutes (e.g., 540)
        const timeToMinutes = (timeStr) => {
          if (!timeStr) return 0;
          const [time, modifier] = timeStr.split(' ');
          let [hours, minutes] = time.split(':').map(Number);
          if (modifier === 'PM' && hours !== 12) hours += 12;
          if (modifier === 'AM' && hours === 12) hours = 0;
          return hours * 60 + minutes;
        };

        const bookingDay = new Date(eventDateFormatted).toLocaleDateString('en-US', { weekday: 'long' });
        const isCorrectDay = hh.dayOfWeek.includes(bookingDay);

        // Convert all times to minutes for comparison
        const selectedStart = timeToMinutes(selectedSlotobj?.start_time);
        const selectedEnd = timeToMinutes(selectedSlotobj?.end_time);
        const hhStart = timeToMinutes(hh.start_time);
        const hhEnd = timeToMinutes(hh.end_time);

        // Check if the selected slot is WITHIN the Happy Hour range
        const isWithinTime = selectedStart >= hhStart && selectedEnd <= hhEnd;

        if (isCorrectDay && isWithinTime) {
          setPackageDetails(prev => ({
            ...prev,
            original_price: prev.price,
            price: hh.override_price
          }));
        } else {
          // REVERT: If conditions don't match, check if we have an original price to go back to
          if (packageDetails.original_price) {
            setPackageDetails(prev => ({
              ...prev,
              price: prev.original_price,
              original_price: null // Clear it out once reverted
            }));
          }
        }
      }
      setActiveStep((prev) => prev + 1);
    } else if (activeStep === 5) {
      console.log("api call");
      setLoader(true);
      debugger
      const today = new Date().toLocaleDateString('en-CA', {
        timeZone: 'Asia/Kolkata'
      });

      var totalamount = (packageDetails.price + addonTotalAmount) - Number(discountAmount);
      let requestObj = {
        "branch_id": branchDetails.ROWID,
        "package_id": packageDetails.ROWID,
        "booking_date": eventDateFormatted,
        "time_slot_id": timeSlotDetails.time_slot_id,
        "customer_name": customerName,
        "customer_phone": customerPhone,
        "customer_email": customerEmail,
        "package_amount": packageDetails.price,
        "addons_amount": addonTotalAmount,
        "discount_amount": discountAmount,
        "advance_amount": Number(advanceAmount),
        "total_amount": Number(totalamount),
        "balance_amount": Number(totalamount) - Number(advanceAmount),
        "cake_note": cakeNote,
        "telecaller_id": currentLoggedInUser?.role_details?.role_name === 'App Administrator' ? null : currentLoggedInUser?.users?.ROWID,
        "source": currentLoggedInUser?.role_details?.role_name === 'App Administrator' ? "WALKIN" : "TELECALLER",
        "status": "PENDING",
        "notes": note,
        "addons": addonArr || [],
        "created_date": today,
        "eventType": selectedEvent
      }

      const bookings = await createBookingApi(requestObj);
      console.log(bookings, 'booking');
      if (bookings.status === 200) {
        if (bookings.data.success === true) {
          setBookingDetails(bookings.data.booking?.data?.[0]);
          setActiveStep((prev) => prev + 1);
        } else {

        }
      }
      setLoader(false);
    }

  };

  const increaseQty = (item) => {
    setAddonQty((prev) => {
      const existing = prev[item.ROWID];

      const quantity = (existing?.quantity || 0) + 1;
      const price = parseInt(item?.branches?.[0]?.price || 0);

      return {
        ...prev,
        [item.ROWID]: {
          addon_id: item.ROWID,
          addon_name: item.name,
          price,
          quantity,
          line_total: price * quantity,
        },
      };
    });
  };

  const decreaseQty = (id) => {
    setAddonQty((prev) => {
      const existing = prev[id];

      if (!existing) return prev;

      if (existing.quantity <= 1) {
        const copy = { ...prev };
        delete copy[id]; // remove addon completely
        return copy;
      }

      const quantity = existing.quantity - 1;

      return {
        ...prev,
        [id]: {
          ...existing,
          quantity,
          line_total: existing.price * quantity,
        },
      };
    });
  };

  useEffect(() => {
    console.log(addonQty, 'addon');
  }, [addonQty, setAddonQty])

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const createNewBookings = () => {
    resetStates();
  }

  const viewBookings = () => {
    resetStates();
    dispatch(setActiveItem('List Bookings'));
  }

  const fetchAllPackages = useCallback(async (selectedBranch, status) => {
    try {
      setLoader(true);
      console.log(selectedBranch, 'selectedBranch');
      const packages = await getPackages(selectedBranch, status);
      const updatedPackages = await Promise.all(packages.map(async (pkg) => {
        const happyhours = await getHappyHours(pkg.ROWID, true);
        if (happyhours && happyhours.length > 0) {
          const hh = happyhours[0]; // Assuming the first rule applies

          // Construct the text (e.g., "Happy Hour: Mon-Fri, 09:00 AM - 01:00 PM @ ₹1499")
          const days = hh.dayOfWeek.map(d => d.substring(0, 3)).join(', ');
          const hhText = ` (Happy Hour: ${days} ${hh.start_time}-${hh.end_time} @ ₹${hh.override_price})`;

          return {
            ...pkg,
            happyhourstext: `${hhText}`,
            hasHappyHour: true,
            override_price: pkg.override_price,
            hhDetails: hh,
            dayOfWeek: pkg.dayOfWeek,
            start_time: pkg.start_time,
            end_time: pkg.end_time
          };
        }
        return pkg;
      }));
      setPackages(updatedPackages);
      setLoader(false);
      console.log(packages, 'packages');
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }, []);

  const fetchAllAddons = useCallback(async (selectedBranch, status) => {
    try {
      setLoader(true);
      console.log(selectedBranch, 'selectedBranch');
      const addons = await getAddons(selectedBranch, status);
      setAddons(addons);
      setLoader(false);
      console.log(addons, 'addons');
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }, []);

  const fetchBranch = useCallback(async () => {
    try {
      setLoader(true);
      const branches = await getBranches(true);
      setBranch(branches);
      setLoader(false);
      console.log(branches, 'branches');
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }, []);

  const fetchTimeSlots = useCallback(async (branch_id, package_id, booking_date) => {
    try {
      setLoader(true);
      const timeSlots = await getAvailableSlotss(branch_id, package_id, booking_date);
      setTimeSlots(timeSlots?.data?.slots);
      setLoader(false);
      console.log(timeSlots, 'timeSlots');
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }, []);


  useEffect(() => {
    fetchBranch();
    let eventTypeArr = [{
      key: "birthday",
      value: "Birthday"
    }, {
      key: "anniversary",
      value: "Anniversary"
    }, {
      key: "brideToBe",
      value: "Bride to be"
    }, {
      key: "groomToBe",
      value: "Groom to be"
    }, {
      key: "loveProposal",
      value: "Love Proposal"
    }, {
      key: "marriageProposal",
      value: "Marriage Proposal"
    }]
    setEventTypeArr(eventTypeArr);
    const today = new Date().toLocaleDateString('en-CA', {
      timeZone: 'Asia/Kolkata',
    });

    setEventDateFormatted(today);

  }, [currentLoggedInUser])

  useEffect(() => {
    console.log(currentLoggedInUser, 'currentLoggedInUser');
    if (currentLoggedInUser?.role_details?.role_name === 'App User') {
      var branch_id = currentLoggedInUser?.users?.branch_id;
      if (branch_id) {
        setSelectedBranch(branch_id);
        branch?.forEach((branch) => {
          if (branch.ROWID === branch_id) {
            setBranchDetails(branch);
          }
        })
        fetchAllPackages(branch_id, true);
        fetchAllAddons(branch_id, true);
      }
    }
  }, [branch]);

  const handleOnChange = (value) => {
    console.log(value, 'value');
    setSelectedBranch(value);
    branch.forEach((branch) => {
      if (branch.ROWID === value) {
        setBranchDetails(branch);
      }
    })
    fetchAllPackages(value, true);
    fetchAllAddons(value, true);
  }

  const handlePackage = async (value) => {
    console.log(value, 'value');
    setSelectedPackage(value);
    packages.forEach((pack) => {
      if (pack.ROWID === value) {
        setPackageDetails(pack);
      }
    })
    await fetchTimeSlots(selectedBranch, value, eventDateFormatted);
  }

  const handleEvent = async (value) => {
    console.log(value, 'value');
    setSelectedEvent(value);
  }

  const handleEventDate = (value) => {
    console.log(value, 'setEventDate');
    setEventDate(value);
    const formattedDate = value ? dayjs(value).format('YYYY-MM-DD') : '';
    console.log(formattedDate);
    setEventDateFormatted(formattedDate);
  }

  useEffect(() => {
    if (timeSlots) {
      timeSlots.forEach((slot) => {
        if (slot.time_slot_id === selectedSlot) {
          setTimeSlotDetails(slot);
        }
      })
    }
  }, [selectedSlot])

  const createPaymentLink = async () => {
    setLoader(true);
    var order_id = `ORDER_${bookingDetails['ROWID']}`;
    let requestObj = {
      "orderId": order_id,
      "amount": Number(advanceAmount),
      "customerName": customerName,
      "email": customerEmail,
      "mobile": customerPhone,
      "booking_id": bookingDetails['ROWID'],
      "status": "PENDING",
      "notes": {
        "booking_id": bookingDetails['ROWID']
      }
    }

    var paymentDetails = await createPaymentLinkApi(requestObj);
    console.log(paymentDetails, 'payment details');
    if (paymentDetails?.data?.success === true) {
      setPaymentLink(paymentDetails?.data);
      setOpenModal(true);
    } else if (paymentDetails?.data?.success === false) {
      setToast({
        message: paymentDetails?.data?.message || 'Unable to create a payment link.',
        type: "error",
      });
    } else {
      setToast({
        message: "Something went wrong, Contact Administrator.",
        type: "error",
      });
    }
  }


  const markComplete = async () => {
    var booking_id = bookingDetails['ROWID'];
    let requestObj = {
      "ROWID": booking_id,
      "status": "BOOKED"
    }

    var updateBooking = await updateBookingStatus(requestObj, booking_id);
    if (updateBooking?.data?.success === true) {
      let requestBody = {
        amount: Number(bookingDetails['advance_amount']),
        payment_method: "Cash",
        notes: "Advance Payment",
        status: "completed"
      }
      var createPayment = await createPaymentApi(requestBody, booking_id);
      console.log(createPayment, 'createPayment');
      if (createPayment?.data?.success === true) {
        setToast({
          message: "Payment completed successfully..",
          type: "success",
        });
        setTimeout(() => {
          viewBookings();
        }, 1000);
      } else if (createPayment?.data?.success === false) {
        setToast({
          message: createPayment?.data?.message || 'Unable to create a payment.',
          type: "error",
        });
      }
    } else {
      setToast({
        message: updateBooking?.data?.message || 'Unable to update booking record.',
        type: "error",
      });
    }
  }

  const handleAdvanceEdit = (packageDetails) => {
    setOpenAdvanceModal(true);
  }

  const closeModal = () => {
    setOpenModal(false);
  }
  const displayDate = eventDateFormatted.split('-').reverse().join('-');

  const closeAdvanceModal = () => {
    setOpenAdvanceModal(false);
  }


  const updateAdvanceAmt = () => {

  }

  return (

    <>      {loader ? (
      <div className="flex items-center justify-center min-h-[60vh] w-full">
        <div className="w-8 h-8 border-4 border-gray-300 border-t-[#72398E] rounded-full animate-spin"></div>
      </div>
    ) :
      <>
        <Notification
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ message: "", type: "success" })} />

        <div className="flex-1 px-4 sm:px-6 py-6 pt-20 lg:pt-6 bg-gradient-to-br from-slate-50 via-white to-slate-100 min-h-screen h-screen overflow-y-auto">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
            <div>
              <h1 className="text-3xl font-bold tracking-tight text-[#72398E]">Booking's</h1>
              <p className="text-sm text-slate-500 mt-2">
                Efficiently manage all bookings from creation to completion. Track event schedules, customer details, selected packages, add-ons, and payment status in real time.
              </p>
            </div>
          </div>

          <ResponsiveStepper activeStep={activeStep}
            onNext={handleNext}
            onBack={handleBack}>

            {activeStep === 0 && <>
              <div className="h-[300px] flex items-center justify-center bg-gray-100 px-4">
                <div className="w-full max-w-md h-[200px] bg-white rounded-xl shadow-md p-6">
                  {branch && branch.length > 0 ?
                    <>
                      <div className='mt-3 w-full'>
                        <label className="block mb-1 text-sm font-medium text-slate-700">
                          Select Branch
                        </label>

                        <div className="relative">
                          <select
                            value={selectedBranch}
                            disabled={currentLoggedInUser?.role_details?.role_name === 'App User' ? true : false}
                            onChange={(e) => handleOnChange(e.target.value)}
                            className="
                              w-full h-11 px-4 pr-10 rounded-xl
                              border border-slate-300 bg-white
                              text-sm text-slate-700
                              focus:outline-none focus:ring-2 focus:ring-[#72398E]
                              focus:border-[#72398E]
                              transition-all duration-200
                              appearance-none cursor-pointer
                            "
                          >
                            <option value="none">Select Branch</option>
                            {branch?.map((r) => (
                              <option key={r.ROWID} value={r.ROWID}>
                                {r.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        {/* </div> */}


                      </div>
                      <div className='mt-5'>
                        <label className="block mb-1 text-sm font-medium text-slate-700">
                          Event Date
                        </label>
                        <BasicDatePicker
                          handleDatePicker={handleEventDate}
                          valueData={eventDate}
                        />
                        {/* min={todayIST} */}
                      </div>
                    </>
                    :
                    ""}
                </div>
              </div>
            </>}
            {activeStep === 1 && <>
              <div className="h-[300px] flex items-center justify-center bg-gray-100 px-4">
                <div className="w-full max-w-md h-[220px] bg-white rounded-xl shadow-md p-6">
                  {packages && packages.length > 0 ?
                    <>
                      <div className='mt-3 w-full'>
                        <label className="block mb-1 text-sm font-medium text-slate-700">
                          Select Package
                        </label>
                        <select
                          value={selectedPackage}
                          onChange={(e) => handlePackage(e.target.value)}
                          className=" w-full h-11 px-4 pr-10 rounded-xl
                        border border-slate-300 bg-white
                        text-sm text-slate-700
                        focus:outline-none focus:ring-2 focus:ring-[#72398E]
                        focus:border-[#72398E]
                        transition-all duration-200
                        appearance-none cursor-pointer"
                        >
                          <option key={0} value="none">Select Theme</option>
                          {packages?.map((r) => (
                            <option key={r.ROWID} value={r.ROWID}>{r.name}</option>
                          ))}
                        </select>

                      </div>

                      <div className='mt-5 w-full'>
                        <label className="block mb-1 text-sm font-medium text-slate-700">
                          Select Event Type
                        </label>
                        <select
                          value={selectedEvent}
                          onChange={(e) => handleEvent(e.target.value)}
                          className="w-full h-11 px-4 pr-10 rounded-xl
                        border border-slate-300 bg-white
                        text-sm text-slate-700
                        focus:outline-none focus:ring-2 focus:ring-[#72398E]
                        focus:border-[#72398E]
                        transition-all duration-200
                        appearance-none cursor-pointe"
                        >
                          <option key={0} value="none">Select event</option>
                          {eventTypeArr?.map((r) => (
                            <option key={r.key} value={r.key}>{r.value}</option>
                          ))}
                        </select>
                      </div>

                    </>
                    :
                    ""}
                </div>
              </div>
            </>}
            {activeStep === 2 && <>
              <div className="py-4 min-h-[350px] items-center justify-center bg-gray-100 px-4">
                <div className="text-center mb-8 mt-4 pt-[10px]">
                  <h2 className="text-2xl font-bold text-gray-800 mb-2">Select a time slot</h2>
                </div>

                <div
                  className="
      grid grid-cols-2 
      sm:grid-cols-3 
      md:grid-cols-4 
      lg:grid-cols-5 
      gap-4 
      max-w-5xl 
      mx-auto
    "
                >
                  {timeSlots?.map((slot) => {
                    const isSelected = selectedSlot === slot.time_slot_id;
                    const isAvailable = slot.is_available; // Using the boolean directly

                    return (
                      <button
                        key={slot.time_slot_id}
                        disabled={!isAvailable}
                        onClick={() => {
                          setSelectedSlotobj(slot);
                          setSelectedSlot(slot.time_slot_id);
                        }}
                        className={` h-16 rounded-xl border text-sm font-medium flex items-center justify-center text-center transition-all duration-200 ${!isAvailable
                          ? "bg-gray-50 text-gray-400 border-gray-200 cursor-not-allowed opacity-60"
                          : isSelected
                            ? "bg-purple-600 text-white border-purple-600 shadow-lg scale-[1.03]"
                            : "bg-white text-slate-700 border-slate-200 hover:border-purple-400 hover:text-purple-600 hover:shadow-md"
                          }
      `}
                      >
                        {slot.label}
                      </button>
                    );
                  })}
                </div>
              </div>
            </>}
            {activeStep === 3 && <>
              <div className="[grid-template-columns:repeat(auto-fit,minmax(240px,1fr))] grid gap-6">
                {addons?.map((item) => {
                  const addon = addonQty[item.ROWID];
                  const qty = addon?.quantity || 0;
                  const isSelected = qty > 0;
                  return (
                    <div
                      key={item.ROWID}
                      className={`
                        relative rounded-2xl bg-white border transition-all duration-300
                        ${isSelected
                          ? "border-blue-600 ring-2 ring-blue-500 shadow-lg"
                          : "border-slate-200 hover:shadow-lg"}
                     `}
                    >
                      {/* Selected Tick */}
                      {isSelected && (
                        <div className="absolute top-3 right-3 bg-blue-600 rounded-full w-6 h-6 flex items-center justify-center shadow">
                          <svg
                            className="w-4 h-4 text-white"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            viewBox="0 0 24 24"
                          >
                            <path d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                      )}

                      {/* Image */}
                      <div className="h-40 w-full overflow-hidden rounded-t-2xl">
                        <img
                          src={item.images?.[0]?.url}
                          alt={item.images?.[0]?.name}
                          className="h-full w-full object-cover transition-transform duration-300 hover:scale-105r"
                        />
                      </div>

                      {/* Content */}
                      <div className="p-3">
                        <h3 className="text-sm font-semibold text-slate-800 leading-tight">
                          {item.name}
                        </h3>

                        <p className="text-xs text-slate-500 mt-1 line-clamp-2">
                          ({item.description})
                        </p>

                        <div className="flex items-center justify-between mt-4">
                          <div>
                            <span className="text-xs text-slate-400">
                              Price
                            </span>
                            <p className="text-base font-bold text-blue-600">
                              ₹{item.branches?.[0]?.price}
                            </p>
                          </div>

                          {/* Qty Controls */}
                          <div
                            className="flex items-center gap-2"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              onClick={() => decreaseQty(item.ROWID)}
                              className="
                              w-8 h-8 rounded-full border border-slate-300
                              flex items-center justify-center
                              text-lg text-slate-600
                              hover:bg-slate-100
                            "
                            >
                              −
                            </button>

                            <span className="w-5 text-center font-semibold">
                              {qty}
                            </span>

                            <button
                              onClick={() => increaseQty(item)}
                              className="
                              w-8 h-8 rounded-full bg-blue-600
                              text-white flex items-center justify-center
                              hover:bg-blue-700
                            "
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

            </>}
            {activeStep === 4 && <>
              <div className="min-h-[300px] flex items-center justify-center bg-gray-100 px-4">
                <div className="w-full max-w-md min-h-[220px] bg-white rounded-xl shadow-md p-6 m-[15px]">
                  <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                    <span className="w-8 h-[1px] bg-slate-200"></span> Customer Details
                  </h3>
                  <div className="mt-5">
                    <FormInput
                      label="Customer Name"
                      value={customerName}
                      onChange={(val) => {
                        setCustomerName((val));
                        setErrors((prev) => ({ ...prev, customerName: null }));
                      }}
                      placeholder="Customer Name"
                      error={errors.customerName}
                    />
                  </div>
                  <div className='mt-5'>
                    <FormInput
                      label="Customer Phone Number"
                      value={customerPhone}
                      onChange={(val) => {
                        setCustomerPhone(val);
                        setErrors((prev) => ({ ...prev, customerPhone: null }));
                      }}
                      placeholder="Customer Phone"
                      error={errors.customerPhone}
                    />
                  </div>
                  <div className='mt-5'>
                    <FormInput
                      label="Customer Email"
                      value={customerEmail}
                      onChange={(val) => {
                        setCustomerEmail(val);
                        setErrors((prev) => ({ ...prev, customerEmail: null }));
                      }}
                      placeholder="Customer Email"
                      error={errors.customerEmail}
                    />
                  </div>
                  <div className='mt-5'>
                    <FormInput
                      label="Cake Note"
                      value={cakeNote}
                      onChange={(val) => {
                        setCakeNote(val);
                        setErrors((prev) => ({ ...prev, cakeNote: null }));
                      }}
                      placeholder="Cake note"
                      error={errors.cakeNote}
                    />
                  </div>
                  <div className='mt-5'>
                    <FormTextareaInput
                      label="Note"
                      value={note}
                      onChange={(val) => {
                        setNote(val);
                        setErrors((prev) => ({ ...prev, Note: null }));
                      }}
                      placeholder="Note"
                      error={errors.Note}
                    />
                  </div>

                  <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2 mt-5">
                    <span className="w-8 h-[1px] bg-slate-200"></span> Advance Amount
                  </h3>
                  <div className="mt-5">
                    <FormInput
                      label="Advance Amount"
                      type='number'
                      value={advanceAmount}
                      onChange={(val) => {

                        setAdvanceAmount((val));
                        setErrors((prev) => ({ ...prev, advanceAmount: null }));
                      }}
                      placeholder="Advance Amount"
                      error={errors.advanceAmount}
                    />
                  </div>
                  <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2 mt-5">
                    <span className="w-8 h-[1px] bg-slate-200"></span> Discount Amount
                  </h3>
                  <div className="mt-5">
                    <FormInput
                      label="Discount Amount"
                      type='number'
                      value={discountAmount}
                      onChange={(val) => {

                        setdiscountAmount((val));
                        setErrors((prev) => ({ ...prev, discountAmount: null }));
                      }}
                      placeholder="Discount Amount"
                      error={errors.discountAmount}
                    />
                  </div>
                </div>
              </div>
            </>}
            {activeStep === 5 && <>
              <div className="max-w-5xl mx-auto px-4 py-6 space-y-6 bg-slate-100 min-h-screen">

                {/* Booking Details */}
                <div className="bg-white rounded-2xl shadow p-5">
                  <h3 className="text-lg font-semibold text-slate-800 mb-4">
                    Booking Details
                  </h3>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                    <div>
                      <p className="text-slate-500">Branch</p>
                      <p className="font-medium">{branchDetails.name}</p>
                    </div>

                    <div>
                      <p className="text-slate-500">Booking Date</p>
                      <p className="font-medium">{displayDate}</p>
                    </div>

                    <div>
                      <p className="text-slate-500">Time Slot</p>
                      <p className="font-medium">{timeSlotDetails.label}</p>
                    </div>

                    <div>
                      <p className="text-slate-500">Package</p>
                      <p className="font-medium">{packageDetails.name}</p>
                    </div>
                  </div>
                </div>

                {/* Add-ons */}
                <div className="bg-white rounded-2xl shadow p-5">
                  <h3 className="text-lg font-semibold text-slate-800 mb-4">
                    Add-ons
                  </h3>

                  <div className="space-y-3">
                    {addonArr && addonArr.length > 0 ?
                      addonArr?.map((addon) => {
                        return (
                          <div key={addon.addon_id} className="flex items-center justify-between border-b pb-2">
                            <div>
                              <p className="font-medium">{addon.addon_name}</p>
                              <p className="text-xs text-slate-500">₹{addon.price} × {addon.quantity}</p>
                            </div>
                            <p className="font-semibold">₹{addon.line_total}</p>
                          </div>
                        )
                      })
                      : ""
                    }
                  </div>
                </div>

                {/* Customer Details */}
                <div className="bg-white rounded-2xl shadow p-5">
                  <h3 className="text-lg font-semibold text-slate-800 mb-4">
                    Customer Details
                  </h3>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                    <div>
                      <p className="text-slate-500">Name</p>
                      <p className="font-medium">{customerName}</p>
                    </div>

                    <div>
                      <p className="text-slate-500">Phone</p>
                      <p className="font-medium">+91 {customerPhone}</p>
                    </div>

                    <div>
                      <p className="text-slate-500">Email</p>
                      <p className="font-medium">{customerEmail}</p>
                    </div>

                    <div>
                      <p className="text-slate-500">Source</p>
                      <p className="font-medium capitalize">{currentLoggedInUser?.role_details?.role_name === 'App Administrator' ? 'WALKIN' : 'TELECALLER'}</p>
                    </div>
                  </div>
                </div>

                {/* Notes */}
                <div className="bg-white rounded-2xl shadow p-5">
                  <h3 className="text-lg font-semibold text-slate-800 mb-4">
                    Notes
                  </h3>

                  <div className="text-sm space-y-2">
                    <p>
                      <span className="text-slate-500">Cake Note:</span>{" "}
                      <span className="font-medium">{cakeNote}</span>
                    </p>

                    {note && <p>
                      <span className="text-slate-500">Internal Notes:</span>{" "}
                      <span className="font-medium">{note}</span>
                    </p>}
                  </div>
                </div>

                {/* Payment Summary */}
                <div className="bg-slate-50 border rounded-2xl p-5">
                  <h3 className="text-lg font-semibold text-slate-800 mb-4">
                    Payment Summary
                  </h3>

                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span>Package Amount</span>
                      <span>₹{packageDetails.price}</span>
                    </div>

                    <div className="flex justify-between">
                      <span>Add-ons Amount</span>
                      <span>₹{addonTotalAmount}</span>
                    </div>

                    <div className="flex justify-between font-semibold border-t pt-2">
                      <span>Total Amount</span>
                      <span>₹ {packageDetails.price + addonTotalAmount}</span>
                    </div>
                    <div className="flex justify-between text-blue-600">
                      <span>Discount Amount</span>
                      <span>- ₹{discountAmount}</span>
                    </div>

                    <div className="flex justify-between text-green-600">
                      <span>Advance to be Pay</span>
                      <span className='flex mt-1 cursor-pointer'>
                        <span>₹{advanceAmount}</span>
                        {/* user / admin can update the advance amount if they need */}
                        {/* <MdOutlineModeEdit className="text-sm m-[3px]" onClick={() => handleAdvanceEdit(packageDetails)} /> */}
                      </span>
                    </div>

                    <div className="flex justify-between text-red-600 font-semibold">
                      <span>Balance Amount</span>
                      <span>₹ {(packageDetails.price + addonTotalAmount - discountAmount) - Number(advanceAmount)}</span>
                    </div>
                  </div>
                </div>

              </div>
            </>}
            {activeStep === 6 && <>
              <div className="flex items-center justify-center min-h-[70vh] px-3 sm:px-6 lg:px-10">
                <div
                  className="
                  w-full
                  max-w-sm sm:max-w-md md:max-w-lg
                  bg-white rounded-2xl
                  shadow-xl border border-slate-100
                  p-5 sm:p-6 md:p-8
                  text-center
                "
                >
                  {/* Success Icon */}
                  <div className="mx-auto flex items-center justify-center 
                      w-16 h-16 sm:w-20 sm:h-20 
                      rounded-full bg-green-100 mb-5 sm:mb-6"
                  >
                    <svg
                      className="w-8 h-8 sm:w-10 sm:h-10 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>

                  {/* Heading */}
                  <h2 className="text-xl sm:text-2xl font-bold text-slate-800">
                    Booking Created Successfully 🎉
                  </h2>

                  {/* Description */}
                  <p className="text-slate-500 mt-3 text-sm sm:text-base leading-relaxed">
                    Your booking has been confirmed and saved successfully.
                    You can review the booking details or create a new booking anytime.
                  </p>

                  {/* Booking Info */}
                  <div
                    className="
                    bg-slate-50 rounded-xl
                    p-3 sm:p-4
                    mt-6
                    text-left text-sm
                    space-y-2
                  "
                  >
                    <div className="flex justify-between gap-2">
                      <span className="text-slate-500">Branch</span>
                      <span className="font-semibold text-slate-700 truncate">
                        {branchDetails.name}
                      </span>
                    </div>

                    <div className="flex justify-between gap-2">
                      <span className="text-slate-500">Customer</span>
                      <span className="font-semibold text-slate-700 truncate">
                        {customerName}
                      </span>
                    </div>

                    <div className="flex justify-between gap-2">
                      <span className="text-slate-500">Booking Date</span>
                      <span className="font-semibold text-slate-700">
                        {eventDateFormatted}
                      </span>
                    </div>

                    <div className="flex justify-between gap-2">
                      <span className="text-slate-500">Total Amount</span>
                      <span className="font-bold text-green-600">
                        ₹{packageDetails.price + addonTotalAmount}
                      </span>
                    </div>

                    <div className="flex justify-between gap-2">
                      <span className="text-slate-500">Advance Amt to pay</span>
                      <span className="font-bold text-green-600">
                        ₹{advanceAmount}
                      </span>
                    </div>

                    <div className="flex justify-between gap-2">
                      <span className="text-slate-500">Create Paymentlink</span>
                      <button
                        type="button"
                        onClick={createPaymentLink}
                        className="
                          inline-flex items-center gap-2
                          px-3 py-1.5
                          rounded-lg
                          font-semibold text-sm
                          text-green-600
                          bg-green-50
                          hover:bg-green-100
                          cursor-pointer
                          transition-all
                        "
                      >
                        <MdLink className="text-lg" />
                        Send Link
                      </button>
                    </div>

                    <div className="flex justify-between gap-2">
                      <span className="text-slate-500">Mark as Paid</span>
                      <button
                        type="button"
                        onClick={markComplete}
                        className="
                          inline-flex items-center gap-2
                          px-3 py-1.5
                          rounded-lg
                          font-semibold text-sm
                          text-green-600
                          bg-green-50
                          hover:bg-green-100
                          cursor-pointer
                          transition-all
                        "
                      >
                        <MdCurrencyRupee className="text-lg" />
                        Collect Cash
                      </button>
                    </div>


                  </div>

                  {/* Actions */}
                  <div className="flex flex-col sm:flex-row gap-3 mt-7 sm:mt-8">
                    <button
                      onClick={() => viewBookings()}
                      className="
                      w-full sm:w-1/2
                      rounded-xl border border-slate-300
                      px-4 py-2.5
                      text-sm font-medium text-slate-700
                      hover:bg-slate-100 transition
                    "
                    >
                      View Booking
                    </button>

                    <button
                      onClick={() => createNewBookings()}
                      className="
                      w-full sm:w-1/2
                      rounded-xl bg-[#72398E]
                      px-4 py-2.5
                      text-sm font-medium text-white
                      hover:bg-purple-700 transition
                    "
                    >
                      New Booking
                    </button>
                  </div>
                </div>
              </div>
            </>}

            <Modal
              open={openModal}
              onClose={closeModal}
              title={"Booking's Payment Link"}
              width="w-full sm:w-[95%] md:max-w-2xl"
            >
              <div className="mx-auto rounded-2xl bg-white">
                <h2 className="text-lg font-semibold text-gray-800">
                  Share Payment Link
                </h2>
                <p className="mt-1 text-sm text-gray-500">
                  We have sent the payment link to the Customer Mobile and Email address of ₹{packageDetails.advance_amount}
                </p>
                <p className="mt-1 text-sm text-gray-500">
                  Copy the link and send it to the customer if they need
                </p>

                <div className="mt-4 flex items-center justify-between gap-3 rounded-xl border border-gray-200 bg-gray-50 p-3">
                  <span className="truncate text-sm text-gray-700">
                    {paymentLink.payment_url}
                  </span>

                  <button
                    onClick={handleCopy}
                    className="flex items-center gap-2 rounded-lg bg-green-600 px-3 py-2 text-sm font-medium text-white hover:bg-green-700 active:scale-95 transition"
                  >
                    <CiLink className="text-xl" />
                    Copy
                  </button>
                </div>

                {copied && (
                  <div className="mt-3 rounded-lg bg-green-100 px-3 py-2 text-sm text-green-700">
                    ✅ Payment link copied successfully
                  </div>
                )}

                <div className="mt-6 flex justify-end">
                  <button
                    className="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>

              </div>
            </Modal>


            {/* <Modal
            open={openAdvanceModal}
            onClose={closeAdvanceModal}
            title={"Update Advance Amt"}
            width="w-full sm:w-[95%] md:max-w-2xl"
          >
            <div className="mx-auto rounded-2xl bg-white">
              <p className="mt-1 text-sm text-gray-500">
                Advance amount must be ₹{packageDetails.advance_amount} or higher.
              </p>

              <div className="mt-5">
                <FormInput
                  label="Advance Amount"
                  type='number'
                  value={advanceAmount}
                  onChange={(val) => {
                    setAdvanceAmount((val));
                    setErrors((prev) => ({ ...prev, advanceAmount: null }));
                  }}
                  placeholder="Advance Amount"
                  error={errors.advanceAmount}
                />
              </div>

              <div className="mt-6 flex justify-end">
                <button
                  className="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100"
                  onClick={closeAdvanceModal}
                >
                  Close
                </button>

                <button
                  className="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100"
                  onClick={updateAdvanceAmt}
                >
                  Update
                </button>

              </div>

            </div>
          </Modal> */}

          </ResponsiveStepper>
        </div>
      </>
    }

    </>
  )
}

function FormInput({
  label,
  value,
  onChange,
  placeholder,
  readOnly,
  disabled,
  type = "text",
  error
}) {
  return (
    <div className="flex flex-col">
      <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        value={value || ""}
        readOnly={readOnly}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full border rounded-xl px-4 py-2.5 text-sm transition-all outline-none 
          ${error ? 'border-rose-400 focus:ring-rose-500/20' : 'border-slate-200 focus:ring-purple-500/10'}
          ${(readOnly || disabled)
            ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
            : 'hover:border-slate-300 focus:ring-4 focus:border-purple-500'}
        `}
      />
      {error && (
        <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium italic">
          {error}
        </span>
      )}
    </div>
  );
}

function FormTextareaInput({
  label,
  value,
  onChange,
  placeholder,
  readOnly,
  disabled,
  type = "text",
  error
}) {
  return (
    <div className="flex flex-col">
      <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
        {label}
      </label>
      <textarea
        type={type}
        placeholder={placeholder}
        value={value || ""}
        readOnly={readOnly}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full border rounded-xl px-4 py-2.5 text-sm transition-all outline-none h-48
          ${error ? 'border-rose-400 focus:ring-rose-500/20' : 'border-slate-200 focus:ring-purple-500/10'}
          ${(readOnly || disabled)
            ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
            : 'hover:border-slate-300 focus:ring-4 focus:border-purple-500'}
        `}
      />
      {error && (
        <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium italic">
          {error}
        </span>
      )}
    </div>
  );
}


export default Bookings